// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"1859c350","200":"bc746360","341":"6871a28b","453":"f6a0aba6","649":"755549ec","717":"a8348fd7","834":"5cd82d33"}[chunkId] + ".chunk.js";
};